import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, StarIcon } from 'lucide-react';
import { PricingSelector } from './PricingSelector';
export function PricingSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-127">
      <div className="space-y-24" data-id="element-128">
        {/* TIER 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden shadow-xl" data-id="element-129">
          <div className="p-8 md:p-12 border-b border-slate-800 bg-slate-900/50" data-id="element-130">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6" data-id="element-131">
              <div data-id="element-132">
                <h3 className="text-3xl font-bold text-white flex items-center gap-3" data-id="element-133">
                  <span className="text-4xl" data-id="element-134">🥉</span> NIVEL 1 — PACK BASE
                </h3>
                <p className="text-xl text-amber-500 mt-2 font-medium" data-id="element-135">
                  "Quiero el conocimiento para profesionalizar mi empresa"
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-136">
                <p className="text-slate-500 line-through text-xl" data-id="element-137">$35.000</p>
              </div>
            </div>
          </div>

          <div className="p-8 md:p-12" data-id="element-138">
            <h4 className="text-xl font-bold text-white mb-8 flex items-center gap-2" data-id="element-139">
              <CheckIcon className="text-emerald-500" data-id="element-140" /> LO QUE INCLUYE:
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-141">
              {/* Tomo 1 */}
              <div data-id="element-142">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-143">
                  📘 TOMO 1: Fundamentos y Estructura Organizacional
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-144">
                  <li className="flex items-start gap-2" data-id="element-145">
                    <span className="text-amber-500 mt-1" data-id="element-146">✦</span> Cómo diseñar
                    la estructura de tu empresa para que cada persona sepa
                    exactamente qué rol cumple
                  </li>
                  <li className="flex items-start gap-2" data-id="element-147">
                    <span className="text-amber-500 mt-1" data-id="element-148">✦</span> Los 5 modelos
                    de estructura organizacional y cuál le conviene a tu empresa
                    según su tamaño y etapa
                  </li>
                  <li className="flex items-start gap-2" data-id="element-149">
                    <span className="text-amber-500 mt-1" data-id="element-150">✦</span> Cómo crear un
                    organigrama que realmente refleje cómo funciona el negocio y
                    no solo cómo quisieras que funcione
                  </li>
                  <li className="flex items-start gap-2" data-id="element-151">
                    <span className="text-amber-500 mt-1" data-id="element-152">✦</span> El error de
                    estructura más común en las PyMEs que duplica los costos sin
                    que nadie lo note
                  </li>
                  <li className="flex items-start gap-2" data-id="element-153">
                    <span className="text-amber-500 mt-1" data-id="element-154">✦</span> Cómo definir
                    niveles jerárquicos claros sin crear burocracia que frene la
                    agilidad
                  </li>
                </ul>
              </div>

              {/* Tomo 2 */}
              <div data-id="element-155">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-156">
                  📗 TOMO 2: Liderazgo y Gestión de Equipos
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-157">
                  <li className="flex items-start gap-2" data-id="element-158">
                    <span className="text-amber-500 mt-1" data-id="element-159">✦</span> Los 4 estilos
                    de liderazgo y cuándo usar cada uno según la madurez de tu
                    equipo
                  </li>
                  <li className="flex items-start gap-2" data-id="element-160">
                    <span className="text-amber-500 mt-1" data-id="element-161">✦</span> Cómo delegar
                    sin perder el control: el sistema de delegación progresiva
                    que usan los mejores gerentes
                  </li>
                  <li className="flex items-start gap-2" data-id="element-162">
                    <span className="text-amber-500 mt-1" data-id="element-163">✦</span> Cómo
                    transformar un equipo de individuos en un equipo de alto
                    rendimiento en menos de 90 días
                  </li>
                  <li className="flex items-start gap-2" data-id="element-164">
                    <span className="text-amber-500 mt-1" data-id="element-165">✦</span> Técnicas de
                    comunicación interna para que tus mensajes lleguen y se
                    implementen sin resistencia
                  </li>
                  <li className="flex items-start gap-2" data-id="element-166">
                    <span className="text-amber-500 mt-1" data-id="element-167">✦</span> Cómo
                    gestionar conflictos internos antes de que destruyan el
                    clima laboral
                  </li>
                </ul>
              </div>

              {/* Tomo 3 */}
              <div data-id="element-168">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-169">
                  📙 TOMO 3: Estrategia y Análisis Empresarial
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-170">
                  <li className="flex items-start gap-2" data-id="element-171">
                    <span className="text-amber-500 mt-1" data-id="element-172">✦</span> Cómo hacer un
                    análisis FODA real que lleve a decisiones concretas y no a
                    un documento que se archiva
                  </li>
                  <li className="flex items-start gap-2" data-id="element-173">
                    <span className="text-amber-500 mt-1" data-id="element-174">✦</span> El proceso de
                    planificación estratégica en 5 pasos adaptado a empresas
                    medianas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-175">
                    <span className="text-amber-500 mt-1" data-id="element-176">✦</span> Cómo definir
                    objetivos que el equipo realmente persiga y no solo que el
                    dueño tenga en la cabeza
                  </li>
                  <li className="flex items-start gap-2" data-id="element-177">
                    <span className="text-amber-500 mt-1" data-id="element-178">✦</span> Las 3
                    herramientas de análisis de mercado más usadas por
                    consultoras de primer nivel
                  </li>
                  <li className="flex items-start gap-2" data-id="element-179">
                    <span className="text-amber-500 mt-1" data-id="element-180">✦</span> Cómo conectar
                    la estrategia del papel con las decisiones del día a día
                  </li>
                </ul>
              </div>

              {/* Tomo 4 */}
              <div data-id="element-181">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-182">
                  📕 TOMO 4: Recursos Humanos y Gestión del Talento
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-183">
                  <li className="flex items-start gap-2" data-id="element-184">
                    <span className="text-amber-500 mt-1" data-id="element-185">✦</span> Cómo
                    construir un proceso de reclutamiento que atraiga a los
                    candidatos correctos y filtre a los incorrectos
                  </li>
                  <li className="flex items-start gap-2" data-id="element-186">
                    <span className="text-amber-500 mt-1" data-id="element-187">✦</span> El sistema de
                    evaluación de desempeño que motiva en lugar de generar
                    resentimiento
                  </li>
                  <li className="flex items-start gap-2" data-id="element-188">
                    <span className="text-amber-500 mt-1" data-id="element-189">✦</span> Cómo retener
                    a tus mejores empleados sin necesariamente pagar más que la
                    competencia
                  </li>
                  <li className="flex items-start gap-2" data-id="element-190">
                    <span className="text-amber-500 mt-1" data-id="element-191">✦</span> Cómo crear
                    una cultura organizacional que trabaje a favor de los
                    resultados
                  </li>
                  <li className="flex items-start gap-2" data-id="element-192">
                    <span className="text-amber-500 mt-1" data-id="element-193">✦</span> El plan de
                    capacitación anual que convierte a tu equipo en una ventaja
                    competitiva real
                  </li>
                </ul>
              </div>

              {/* Tomo 5 */}
              <div data-id="element-194">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-195">
                  📒 TOMO 5: Gestión de Proyectos y Operaciones
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-196">
                  <li className="flex items-start gap-2" data-id="element-197">
                    <span className="text-amber-500 mt-1" data-id="element-198">✦</span> El marco de
                    gestión de proyectos simplificado para empresas que no
                    tienen un departamento de PMO
                  </li>
                  <li className="flex items-start gap-2" data-id="element-199">
                    <span className="text-amber-500 mt-1" data-id="element-200">✦</span> Cómo lograr
                    que los proyectos se entreguen en tiempo, dentro del
                    presupuesto y con la calidad esperada
                  </li>
                  <li className="flex items-start gap-2" data-id="element-201">
                    <span className="text-amber-500 mt-1" data-id="element-202">✦</span> Las métricas
                    operativas que todo gerente debería mirar cada semana pero
                    casi ninguno mira
                  </li>
                  <li className="flex items-start gap-2" data-id="element-203">
                    <span className="text-amber-500 mt-1" data-id="element-204">✦</span> Cómo
                    identificar y eliminar los cuellos de botella que frenan la
                    productividad de tu operación
                  </li>
                  <li className="flex items-start gap-2" data-id="element-205">
                    <span className="text-amber-500 mt-1" data-id="element-206">✦</span> El sistema de
                    mejora continua que hace que tu empresa sea más eficiente
                    cada trimestre
                  </li>
                </ul>
              </div>

              {/* Tomo 6 */}
              <div data-id="element-207">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-208">
                  📓 TOMO 6: Innovación y Cambio Organizacional
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-209">
                  <li className="flex items-start gap-2" data-id="element-210">
                    <span className="text-amber-500 mt-1" data-id="element-211">✦</span> Cómo liderar
                    procesos de cambio sin que el equipo entre en pánico o
                    sabotee la transformación
                  </li>
                  <li className="flex items-start gap-2" data-id="element-212">
                    <span className="text-amber-500 mt-1" data-id="element-213">✦</span> Las 7 etapas
                    del cambio organizacional y qué hacer en cada una para no
                    perder personas clave
                  </li>
                  <li className="flex items-start gap-2" data-id="element-214">
                    <span className="text-amber-500 mt-1" data-id="element-215">✦</span> Cómo crear
                    una cultura de innovación en una empresa que siempre hizo
                    las cosas de la misma manera
                  </li>
                  <li className="flex items-start gap-2" data-id="element-216">
                    <span className="text-amber-500 mt-1" data-id="element-217">✦</span> El mapa de
                    actores del cambio: quiénes serán tus aliados y quiénes tus
                    resistentes desde el primer día
                  </li>
                  <li className="flex items-start gap-2" data-id="element-218">
                    <span className="text-amber-500 mt-1" data-id="element-219">✦</span> Cómo medir si
                    el proceso de cambio está funcionando antes de que sea
                    demasiado tarde para corregir
                  </li>
                </ul>
              </div>
            </div>

            {/* Bonos Nivel 1 */}
            <div className="mt-12 p-6 bg-slate-800/50 rounded-xl border border-slate-700" data-id="element-220">
              <h5 className="text-xl font-bold text-amber-500 mb-6" data-id="element-221">
                🎁 BONOS INCLUIDOS:
              </h5>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-222">
                <div data-id="element-223">
                  <strong className="text-white block mb-2" data-id="element-224">
                    Bono 1: Checklists de Gestión
                  </strong>
                  <ul className="text-sm text-slate-300 space-y-1" data-id="element-225">
                    <li data-id="element-226">✦ 15 checklists listos para usar</li>
                    <li data-id="element-227">✦ Auditoría hasta clima laboral</li>
                    <li data-id="element-228">✦ Formato imprimible y digital</li>
                  </ul>
                </div>
                <div data-id="element-229">
                  <strong className="text-white block mb-2" data-id="element-230">
                    Bono 2: Frameworks y Modelos
                  </strong>
                  <ul className="text-sm text-slate-300 space-y-1" data-id="element-231">
                    <li data-id="element-232">✦ 20 frameworks de consultoría</li>
                    <li data-id="element-233">✦ BSC, Canvas, McKinsey 7S</li>
                    <li data-id="element-234">✦ Explicación práctica de uso</li>
                  </ul>
                </div>
                <div data-id="element-235">
                  <strong className="text-white block mb-2" data-id="element-236">
                    Bono 3: Plantillas Base
                  </strong>
                  <ul className="text-sm text-slate-300 space-y-1" data-id="element-237">
                    <li data-id="element-238">✦ Documentos editables clave</li>
                    <li data-id="element-239">✦ Actas, informes, organigramas</li>
                    <li data-id="element-240">✦ Word, Google Docs y PDF</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-10 border-l-4 border-emerald-500 pl-6 py-2" data-id="element-241">
              <p className="text-lg text-slate-300 italic mb-2" data-id="element-242">
                "Con solo el Tomo 1 ya entendí por qué mi empresa era un caos.
                Reorganicé toda la estructura en 3 semanas y por primera vez en
                4 años siento que tengo el control."
              </p>
              <p className="text-white font-bold" data-id="element-243">
                — Martín G., dueño de empresa de logística
              </p>
            </div>
          </div>
        </motion.div>

        {/* TIER 2 - HIGHLIGHTED */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative bg-slate-900 border-2 border-emerald-500 rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(34,197,94,0.15)] transform md:scale-[1.02] z-10" data-id="element-244">
          <div className="p-8 md:p-12 border-b border-slate-800 bg-emerald-950/20 pt-14" data-id="element-245">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6" data-id="element-246">
              <div data-id="element-247">
                <h3 className="text-3xl font-bold text-white flex items-center gap-3" data-id="element-248">
                  <span className="text-4xl" data-id="element-249">🥈</span> NIVEL 2 — PACK
                  IMPLEMENTACIÓN
                </h3>
                <p className="text-xl text-emerald-400 mt-2 font-medium" data-id="element-250">
                  "Quiero el conocimiento Y las herramientas para implementarlo
                  sin perder tiempo"
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-251">
                <p className="text-slate-500 line-through text-xl" data-id="element-252">$55.000</p>
              </div>
            </div>
          </div>

          <div className="p-8 md:p-12 text-[#000000]" data-id="element-253">
            <h4 className="text-xl font-bold text-white mb-8 flex items-center gap-2" data-id="element-254">
              <CheckIcon className="text-emerald-500" data-id="element-255" /> TODO LO DEL NIVEL 1,
              MÁS:
            </h4>

            <div className="mb-10 text-center p-6 bg-slate-800/50 rounded-xl border border-slate-700" data-id="element-256">
              <h5 className="text-2xl font-bold text-white mb-2" data-id="element-257">
                🔧 THE EXECUTION TOOLKIT
              </h5>
              <p className="text-emerald-400 italic" data-id="element-258">
                El puente entre saber qué hacer y tener los documentos
                funcionando en tu empresa esta semana
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-259">
              {/* Módulo 1 */}
              <div data-id="element-260">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-261">
                  📋 MÓDULO 1: Biblioteca de Perfiles de Puesto
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-262">
                  <li className="flex items-start gap-2" data-id="element-263">
                    <span className="text-emerald-500 mt-1" data-id="element-264">✦</span> 25 perfiles
                    de puesto profesionales pre-redactados y listos para
                    personalizar en menos de 30 minutos
                  </li>
                  <li className="flex items-start gap-2" data-id="element-265">
                    <span className="text-emerald-500 mt-1" data-id="element-266">✦</span> Incluye los
                    puestos más críticos de cualquier PyME: Gerente General,
                    Comercial, RRHH, Operaciones, Ventas, Administración y más
                  </li>
                  <li className="flex items-start gap-2" data-id="element-267">
                    <span className="text-emerald-500 mt-1" data-id="element-268">✦</span> Cada perfil
                    incluye misión del puesto, responsabilidades, KPIs y
                    competencias conductuales
                  </li>
                  <li className="flex items-start gap-2" data-id="element-269">
                    <span className="text-emerald-500 mt-1" data-id="element-270">✦</span> Formato
                    editable en Word para que lo adaptes a la realidad de tu
                    empresa sin empezar desde cero
                  </li>
                  <li className="flex items-start gap-2" data-id="element-271">
                    <span className="text-emerald-500 mt-1" data-id="element-272">✦</span> El mismo
                    formato que usan las consultoras de RRHH y que cobran $500
                    USD por cada perfil redactado
                  </li>
                </ul>
              </div>

              {/* Módulo 2 */}
              <div data-id="element-273">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-274">
                  📋 MÓDULO 2: Manual de Procedimientos Estándar (SOPs)
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-275">
                  <li className="flex items-start gap-2" data-id="element-276">
                    <span className="text-emerald-500 mt-1" data-id="element-277">✦</span> La
                    estructura exacta para documentar cualquier proceso de tu
                    empresa en menos de 45 minutos
                  </li>
                  <li className="flex items-start gap-2" data-id="element-278">
                    <span className="text-emerald-500 mt-1" data-id="element-279">✦</span> 3 SOPs
                    modelo ya redactados: Atención al Cliente, Alta de
                    Proveedores y Cierre Mensual Administrativo
                  </li>
                  <li className="flex items-start gap-2" data-id="element-280">
                    <span className="text-emerald-500 mt-1" data-id="element-281">✦</span> Cómo hacer
                    que tu equipo documente sus propios procesos sin resistencia
                    y sin que te lleve semanas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-282">
                    <span className="text-emerald-500 mt-1" data-id="element-283">✦</span> El sistema
                    de codificación y versioning para que tus documentos nunca
                    queden desactualizados
                  </li>
                  <li className="flex items-start gap-2" data-id="element-284">
                    <span className="text-emerald-500 mt-1" data-id="element-285">✦</span> La
                    diferencia entre una empresa donde el conocimiento está en
                    la cabeza de las personas y una donde está en los documentos
                  </li>
                </ul>
              </div>

              {/* Módulo 3 */}
              <div data-id="element-286">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-287">
                  📋 MÓDULO 3: Kit de Reclutamiento y Selección
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-288">
                  <li className="flex items-start gap-2" data-id="element-289">
                    <span className="text-emerald-500 mt-1" data-id="element-290">✦</span> Plantilla
                    de aviso laboral profesional que atrae a los candidatos
                    correctos desde el título
                  </li>
                  <li className="flex items-start gap-2" data-id="element-291">
                    <span className="text-emerald-500 mt-1" data-id="element-292">✦</span> Guía
                    completa de entrevista por competencias con más de 20
                    preguntas listas para usar por categoría
                  </li>
                  <li className="flex items-start gap-2" data-id="element-293">
                    <span className="text-emerald-500 mt-1" data-id="element-294">✦</span> El método
                    STAR explicado paso a paso para que cualquier líder de tu
                    empresa pueda entrevistar bien
                  </li>
                  <li className="flex items-start gap-2" data-id="element-295">
                    <span className="text-emerald-500 mt-1" data-id="element-296">✦</span> Grilla de
                    evaluación de candidatos con sistema de puntaje ponderado
                    para tomar decisiones objetivas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-297">
                    <span className="text-emerald-500 mt-1" data-id="element-298">✦</span> Carta de
                    oferta laboral modelo lista para personalizar y enviar
                  </li>
                </ul>
              </div>

              {/* Módulo 4 */}
              <div data-id="element-299">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-300">
                  📋 MÓDULO 4: Checklist de Inducción y Onboarding
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-301">
                  <li className="flex items-start gap-2" data-id="element-302">
                    <span className="text-emerald-500 mt-1" data-id="element-303">✦</span> El plan
                    completo de bienvenida para el Día 1, la Semana 1 y el Mes 1
                    de cualquier nuevo empleado
                  </li>
                  <li className="flex items-start gap-2" data-id="element-304">
                    <span className="text-emerald-500 mt-1" data-id="element-305">✦</span> Formulario
                    de evaluación del período de onboarding con escala de
                    decisión clara
                  </li>
                  <li className="flex items-start gap-2" data-id="element-306">
                    <span className="text-emerald-500 mt-1" data-id="element-307">✦</span> Carta de
                    bienvenida corporativa lista para personalizar con tu marca
                  </li>
                  <li className="flex items-start gap-2" data-id="element-308">
                    <span className="text-emerald-500 mt-1" data-id="element-309">✦</span> El
                    protocolo que reduce el tiempo de adaptación de un nuevo
                    empleado de 3 meses a 3 semanas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-310">
                    <span className="text-emerald-500 mt-1" data-id="element-311">✦</span> Cómo
                    convertir cada nueva contratación en un activo productivo
                    desde los primeros días
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono Nivel 2 */}
            <div className="mt-12 p-6 bg-emerald-900/20 rounded-xl border border-emerald-500/30" data-id="element-312">
              <h5 className="text-xl font-bold text-emerald-400 mb-4 flex items-center gap-2" data-id="element-313">
                🗓️ BONUS EXCLUSIVO NIVEL 2: Plan de Implementación de 30 Días
              </h5>
              <ul className="space-y-2 text-slate-300" data-id="element-314">
                <li className="flex items-start gap-2" data-id="element-315">
                  <span className="text-emerald-500" data-id="element-316">✦</span> Un plan día a día
                  que te dice exactamente qué implementar cada día durante el
                  primer mes
                </li>
                <li className="flex items-start gap-2" data-id="element-317">
                  <span className="text-emerald-500" data-id="element-318">✦</span> Sin parálisis por
                  análisis: sabés con exactitud por dónde empezar y qué viene
                  después
                </li>
                <li className="flex items-start gap-2" data-id="element-319">
                  <span className="text-emerald-500" data-id="element-320">✦</span> Con métricas de
                  antes y después para que puedas medir el impacto real en tu
                  organización
                </li>
              </ul>
            </div>

            <div className="mt-10 border-l-4 border-amber-500 pl-6 py-2" data-id="element-321">
              <p className="text-lg text-slate-300 italic mb-2" data-id="element-322">
                "Tenía los conocimientos pero siempre postergaba porque no sabía
                por dónde arrancar. Con el Kit de Implementación tuve los
                perfiles de puesto de mis 8 empleados listos en 3 días. Algo que
                venía debiendo hace 2 años."
              </p>
              <p className="text-white font-bold" data-id="element-323">
                — Carolina M., directora de agencia de marketing
              </p>
            </div>
          </div>
        </motion.div>

        {/* TIER 3 */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative bg-slate-900 border-2 border-amber-500 rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(245,158,11,0.15)] transform md:scale-[1.02] z-10" data-id="element-324">
          <div className="p-8 md:p-12 border-b border-slate-800 bg-amber-950/20 pt-14" data-id="element-325">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6" data-id="element-326">
              <div data-id="element-327">
                <h3 className="text-3xl font-bold text-white flex items-center gap-3" data-id="element-328">
                  <span className="text-4xl" data-id="element-329">🥇</span> NIVEL 3 — PACK CONTROL
                  TOTAL
                </h3>
                <p className="text-xl text-amber-500 mt-2 font-medium" data-id="element-330">
                  "Quiero el conocimiento, las herramientas Y el sistema para
                  dirigir mi empresa con datos en lugar de intuición"
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-331">
                <p className="text-slate-500 line-through text-xl" data-id="element-332">$75.000</p>
              </div>
            </div>
          </div>

          <div className="p-8 md:p-12" data-id="element-333">
            <h4 className="text-xl font-bold text-white mb-8 flex items-center gap-2" data-id="element-334">
              <CheckIcon className="text-emerald-500" data-id="element-335" /> TODO LO DEL NIVEL 1 Y
              NIVEL 2, MÁS:
            </h4>

            <div className="mb-10 text-center p-6 bg-slate-800/50 rounded-xl border border-slate-700" data-id="element-336">
              <h5 className="text-2xl font-bold text-white mb-2" data-id="element-337">
                🏆 THE GOVERNANCE SYSTEM
              </h5>
              <p className="text-amber-500 italic" data-id="element-338">
                El tablero de control que usan los CEOs para saber exactamente
                qué está pasando en su empresa en 15 minutos al día
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-339">
              {/* Módulo 1 */}
              <div data-id="element-340">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-341">
                  📊 MÓDULO 1: Tablero de Comando y KPIs Estratégicos
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-342">
                  <li className="flex items-start gap-2" data-id="element-343">
                    <span className="text-amber-500 mt-1" data-id="element-344">✦</span> El sistema de
                    Balanced Scorecard simplificado para PyMEs: cómo medir tu
                    empresa desde las 4 perspectivas que realmente importan
                  </li>
                  <li className="flex items-start gap-2" data-id="element-345">
                    <span className="text-amber-500 mt-1" data-id="element-346">✦</span> Plantilla
                    completa del Tablero de KPIs con semáforo visual para
                    detectar problemas antes de que se conviertan en crisis
                  </li>
                  <li className="flex items-start gap-2" data-id="element-347">
                    <span className="text-amber-500 mt-1" data-id="element-348">✦</span> Cómo definir
                    los objetivos estratégicos anuales en una sesión de 60
                    minutos con tu equipo directivo
                  </li>
                  <li className="flex items-start gap-2" data-id="element-349">
                    <span className="text-amber-500 mt-1" data-id="element-350">✦</span> El protocolo
                    de respuesta para cuando un KPI está en rojo: qué hacer,
                    quién lo hace y en cuánto tiempo
                  </li>
                  <li className="flex items-start gap-2" data-id="element-351">
                    <span className="text-amber-500 mt-1" data-id="element-352">✦</span> Calculadora
                    de Rentabilidad Operativa con las 6 fórmulas financieras que
                    todo dueño de empresa debe dominar
                  </li>
                  <li className="flex items-start gap-2" data-id="element-353">
                    <span className="text-amber-500 mt-1" data-id="element-354">✦</span> Cómo pasar de
                    gestionar por intuición a gestionar por datos sin necesitar
                    ser contador ni experto en finanzas
                  </li>
                </ul>
              </div>

              {/* Módulo 2 */}
              <div data-id="element-355">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-356">
                  🚀 MÓDULO 2: Sistema de Gestión de Proyectos Ágil
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-357">
                  <li className="flex items-start gap-2" data-id="element-358">
                    <span className="text-amber-500 mt-1" data-id="element-359">✦</span> La Ficha de
                    Inicio de Proyecto que elimina el 70% de los malentendidos
                    antes de que el proyecto arranque
                  </li>
                  <li className="flex items-start gap-2" data-id="element-360">
                    <span className="text-amber-500 mt-1" data-id="element-361">✦</span> Cronograma
                    Gantt simplificado: cómo tener visibilidad total del avance
                    de cada proyecto en una sola hoja
                  </li>
                  <li className="flex items-start gap-2" data-id="element-362">
                    <span className="text-amber-500 mt-1" data-id="element-363">✦</span> El Tablero
                    Kanban adaptado para PyMEs: cómo hacer visible el trabajo de
                    todo el equipo sin software costoso
                  </li>
                  <li className="flex items-start gap-2" data-id="element-364">
                    <span className="text-amber-500 mt-1" data-id="element-365">✦</span> Plantilla de
                    Reporte Quincenal de Avance para que el sponsor siempre sepa
                    en qué estado está cada proyecto
                  </li>
                  <li className="flex items-start gap-2" data-id="element-366">
                    <span className="text-amber-500 mt-1" data-id="element-367">✦</span> Acta de
                    Cierre de Proyecto con lecciones aprendidas para que cada
                    proyecto haga a tu empresa más inteligente
                  </li>
                  <li className="flex items-start gap-2" data-id="element-368">
                    <span className="text-amber-500 mt-1" data-id="element-369">✦</span> Cómo lograr
                    que el 90% de tus proyectos se entreguen en tiempo cuando
                    hoy probablemente el 30% lo hacen
                  </li>
                </ul>
              </div>

              {/* Módulo 3 */}
              <div data-id="element-370">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-371">
                  🤝 MÓDULO 3: Protocolo de Reuniones de Alta Gerencia
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-372">
                  <li className="flex items-start gap-2" data-id="element-373">
                    <span className="text-amber-500 mt-1" data-id="element-374">✦</span> El sistema de
                    3 tipos de reuniones que elimina el 60% de las reuniones
                    improductivas de tu empresa
                  </li>
                  <li className="flex items-start gap-2" data-id="element-375">
                    <span className="text-amber-500 mt-1" data-id="element-376">✦</span> Agenda exacta
                    de la Reunión Operativa Semanal de 60 minutos que realmente
                    resuelve problemas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-377">
                    <span className="text-amber-500 mt-1" data-id="element-378">✦</span> Agenda de la
                    Reunión Estratégica Mensual de 120 minutos para revisar KPIs
                    y tomar decisiones de alto impacto
                  </li>
                  <li className="flex items-start gap-2" data-id="element-379">
                    <span className="text-amber-500 mt-1" data-id="element-380">✦</span> El formato de
                    Revisión Trimestral Estratégica que usan los directorios de
                    las empresas más exitosas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-381">
                    <span className="text-amber-500 mt-1" data-id="element-382">✦</span> Plantilla de
                    Acta de Reunión con sistema de compromisos y seguimiento
                    para que ninguna decisión quede en el olvido
                  </li>
                  <li className="flex items-start gap-2" data-id="element-383">
                    <span className="text-amber-500 mt-1" data-id="element-384">✦</span> Cómo
                    transformar las reuniones de tu empresa de un gasto de
                    tiempo en el motor de ejecución de tu estrategia
                  </li>
                </ul>
              </div>

              {/* Módulo 4 */}
              <div data-id="element-385">
                <h5 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-386">
                  ⚠️ MÓDULO 4: Matriz de Riesgos y Contingencias
                </h5>
                <ul className="space-y-3 text-slate-300" data-id="element-387">
                  <li className="flex items-start gap-2" data-id="element-388">
                    <span className="text-amber-500 mt-1" data-id="element-389">✦</span> El Registro
                    Maestro de Riesgos con las 4 categorías críticas de
                    cualquier PyME: financieros, operativos, de mercado y de
                    RRHH
                  </li>
                  <li className="flex items-start gap-2" data-id="element-390">
                    <span className="text-amber-500 mt-1" data-id="element-391">✦</span> La Matriz de
                    Evaluación 3x3 que te permite priorizar en cuáles riesgos
                    actuar hoy y cuáles monitorear
                  </li>
                  <li className="flex items-start gap-2" data-id="element-392">
                    <span className="text-amber-500 mt-1" data-id="element-393">✦</span> Planes de
                    contingencia pre-diseñados para los 12 riesgos más
                    frecuentes en empresas medianas latinoamericanas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-394">
                    <span className="text-amber-500 mt-1" data-id="element-395">✦</span> El Protocolo
                    de Crisis en 4 fases para que cuando algo salga mal tu
                    equipo sepa exactamente qué hacer sin que tengas que estar
                    presente
                  </li>
                  <li className="flex items-start gap-2" data-id="element-396">
                    <span className="text-amber-500 mt-1" data-id="element-397">✦</span> Cómo pasar de
                    ser la empresa que reacciona a las crisis a ser la empresa
                    que las previene
                  </li>
                  <li className="flex items-start gap-2" data-id="element-398">
                    <span className="text-amber-500 mt-1" data-id="element-399">✦</span> La diferencia
                    entre las empresas que sobreviven 10 años y las que no: no
                    es el mercado, es la preparación
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono Nivel 3 */}
            <div className="mt-12 p-6 bg-slate-800/50 rounded-xl border border-slate-700" data-id="element-400">
              <h5 className="text-xl font-bold text-amber-500 mb-4 flex items-center gap-2" data-id="element-401">
                🗓️ BONUS EXCLUSIVO NIVEL 3: Plan de Implementación de 30 Días
                del Governance System
              </h5>
              <ul className="space-y-2 text-slate-300" data-id="element-402">
                <li className="flex items-start gap-2" data-id="element-403">
                  <span className="text-amber-500" data-id="element-404">✦</span> Semana a semana:
                  cómo activar los 4 módulos del Governance System en 30 días
                  sin paralizar la operación
                </li>
                <li className="flex items-start gap-2" data-id="element-405">
                  <span className="text-amber-500" data-id="element-406">✦</span> La tabla de métricas
                  de éxito para medir el antes y después de tener un sistema de
                  control real
                </li>
                <li className="flex items-start gap-2" data-id="element-407">
                  <span className="text-amber-500" data-id="element-408">✦</span> El checklist de
                  integración para conectar el Governance System con el
                  Execution Toolkit del Nivel 2
                </li>
              </ul>
            </div>

            <div className="mt-10 border-l-4 border-emerald-500 pl-6 py-2" data-id="element-409">
              <p className="text-lg text-slate-300 italic mb-2" data-id="element-410">
                "Antes gestionaba mi empresa con el WhatsApp y el instinto. Hoy
                tengo un tablero de KPIs que reviso cada lunes en 20 minutos y
                sé exactamente qué área necesita atención. Contraté a una
                gerente hace 3 meses y por primera vez en 8 años me fui de
                vacaciones sin revisar el correo."
              </p>
              <p className="text-white font-bold" data-id="element-411">
                — Roberto S., propietario de empresa de servicios industriales
              </p>
            </div>
          </div>
        </motion.div>

        <PricingSelector data-id="element-412" />

        {/* COMPARISON TABLE */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-24" data-id="element-413">
          <h3 className="text-3xl font-bold text-white text-center mb-10" data-id="element-414">
            COMPARATIVA DE NIVELES
          </h3>

          {/* DESKTOP TABLE */}
          <div className="hidden md:block overflow-x-auto" data-id="element-415">
            <table className="w-full text-left border-collapse" data-id="element-416">
              <thead data-id="element-417">
                <tr data-id="element-418">
                  <th className="p-4 border-b border-slate-700 text-slate-300 font-medium" data-id="element-419"></th>
                  <th className="p-4 border-b border-slate-700 text-center text-white font-bold bg-slate-800/30 rounded-t-lg" data-id="element-420">
                    🥉 PACK BASE
                  </th>
                  <th className="p-4 border-b border-emerald-500 text-center text-emerald-400 font-bold bg-emerald-900/20 rounded-t-lg border-t-2 border-x-2" data-id="element-421">
                    🥈 PACK IMPLEMENTACIÓN
                  </th>
                  <th className="p-4 border-b border-amber-500 text-center text-amber-400 font-bold bg-amber-900/20 rounded-t-lg border-t-2 border-x-2" data-id="element-422">
                    🥇 PACK CONTROL TOTAL
                  </th>
                </tr>
              </thead>
              <tbody className="text-slate-300" data-id="element-423">
                {[{
                feature: '6 Tomos de Gestión Organizacional',
                t1: true,
                t2: true,
                t3: true
              }, {
                feature: '3 Bonos Base (Checklists, Frameworks, Plantillas)',
                t1: true,
                t2: true,
                t3: true
              }, {
                feature: 'Biblioteca de 25 Perfiles de Puesto',
                t1: false,
                t2: true,
                t3: true
              }, {
                feature: 'Manual de SOPs con plantillas',
                t1: false,
                t2: true,
                t3: true
              }, {
                feature: 'Kit de Reclutamiento y Selección',
                t1: false,
                t2: true,
                t3: true
              }, {
                feature: 'Sistema de Onboarding completo',
                t1: false,
                t2: true,
                t3: true
              }, {
                feature: 'Plan de Implementación 30 Días (Toolkit)',
                t1: false,
                t2: true,
                t3: true
              }, {
                feature: 'Tablero de KPIs y Balanced Scorecard',
                t1: false,
                t2: false,
                t3: true
              }, {
                feature: 'Sistema de Gestión de Proyectos Ágil',
                t1: false,
                t2: false,
                t3: true
              }, {
                feature: 'Protocolo de Reuniones de Alta Gerencia',
                t1: false,
                t2: false,
                t3: true
              }, {
                feature: 'Matriz de Riesgos y Contingencias',
                t1: false,
                t2: false,
                t3: true
              }, {
                feature: 'Plan de Implementación 30 Días (Governance)',
                t1: false,
                t2: false,
                t3: true
              }].map((row, i) => <tr key={i} className="border-b border-slate-800 hover:bg-slate-800/30 transition-colors" data-id="element-424">
                    <td className="p-4 font-medium" data-id="element-425">{row.feature}</td>
                    <td className="p-4 text-center bg-slate-800/10" data-id="element-426">
                      {row.t1 ? <CheckIcon className="w-5 h-5 text-emerald-500 mx-auto" data-id="element-427" /> : <XIcon className="w-5 h-5 text-slate-600 mx-auto" data-id="element-428" />}
                    </td>
                    <td className="p-4 text-center bg-emerald-900/10 border-x-2 border-emerald-500/30" data-id="element-429">
                      {row.t2 ? <CheckIcon className="w-5 h-5 text-emerald-500 mx-auto" data-id="element-430" /> : <XIcon className="w-5 h-5 text-slate-600 mx-auto" data-id="element-431" />}
                    </td>
                    <td className="p-4 text-center bg-amber-900/10 border-x-2 border-amber-500/30" data-id="element-432">
                      {row.t3 ? <CheckIcon className="w-5 h-5 text-emerald-500 mx-auto" data-id="element-433" /> : <XIcon className="w-5 h-5 text-slate-600 mx-auto" data-id="element-434" />}
                    </td>
                  </tr>)}
                <tr data-id="element-435">
                  <td className="p-6 font-bold text-white text-right" data-id="element-436">
                    PRECIO
                  </td>
                  <td className="p-6 text-center font-bold text-2xl text-white bg-slate-800/30 rounded-b-lg" data-id="element-437">
                    $19.990
                  </td>
                  <td className="p-6 text-center font-bold text-2xl text-white bg-emerald-900/20 border-b-2 border-x-2 border-emerald-500 rounded-b-lg" data-id="element-438">
                    $29.990
                  </td>
                  <td className="p-6 text-center font-bold text-2xl text-amber-400 bg-amber-900/20 border-b-2 border-x-2 border-amber-500 rounded-b-lg" data-id="element-439">
                    $39.990
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* MOBILE CARDS */}
          <div className="md:hidden space-y-8" data-id="element-440">
            {[{
            title: '🥉 PACK BASE',
            price: '$19.990',
            features: [{
              name: '6 Tomos de Gestión Organizacional',
              included: true
            }, {
              name: '3 Bonos Base (Checklists, Frameworks, Plantillas)',
              included: true
            }, {
              name: 'Biblioteca de 25 Perfiles de Puesto',
              included: false
            }, {
              name: 'Manual de SOPs con plantillas',
              included: false
            }, {
              name: 'Kit de Reclutamiento y Selección',
              included: false
            }, {
              name: 'Sistema de Onboarding completo',
              included: false
            }, {
              name: 'Plan de Implementación 30 Días (Toolkit)',
              included: false
            }, {
              name: 'Tablero de KPIs y Balanced Scorecard',
              included: false
            }, {
              name: 'Sistema de Gestión de Proyectos Ágil',
              included: false
            }, {
              name: 'Protocolo de Reuniones de Alta Gerencia',
              included: false
            }, {
              name: 'Matriz de Riesgos y Contingencias',
              included: false
            }, {
              name: 'Plan de Implementación 30 Días (Governance)',
              included: false
            }],
            style: 'border-slate-700 bg-slate-900',
            headerStyle: 'bg-slate-800/50 border-slate-700 text-white',
            priceStyle: 'text-white'
          }, {
            title: '🥈 PACK IMPLEMENTACIÓN',
            price: '$29.990',
            features: [{
              name: '6 Tomos de Gestión Organizacional',
              included: true
            }, {
              name: '3 Bonos Base (Checklists, Frameworks, Plantillas)',
              included: true
            }, {
              name: 'Biblioteca de 25 Perfiles de Puesto',
              included: true
            }, {
              name: 'Manual de SOPs con plantillas',
              included: true
            }, {
              name: 'Kit de Reclutamiento y Selección',
              included: true
            }, {
              name: 'Sistema de Onboarding completo',
              included: true
            }, {
              name: 'Plan de Implementación 30 Días (Toolkit)',
              included: true
            }, {
              name: 'Tablero de KPIs y Balanced Scorecard',
              included: false
            }, {
              name: 'Sistema de Gestión de Proyectos Ágil',
              included: false
            }, {
              name: 'Protocolo de Reuniones de Alta Gerencia',
              included: false
            }, {
              name: 'Matriz de Riesgos y Contingencias',
              included: false
            }, {
              name: 'Plan de Implementación 30 Días (Governance)',
              included: false
            }],
            style: 'border-emerald-500/50 border-2 bg-slate-900',
            headerStyle: 'bg-emerald-900/20 border-emerald-500/30 text-white',
            priceStyle: 'text-white'
          }, {
            title: '🥇 PACK CONTROL TOTAL',
            price: '$39.990',
            features: [{
              name: '6 Tomos de Gestión Organizacional',
              included: true
            }, {
              name: '3 Bonos Base (Checklists, Frameworks, Plantillas)',
              included: true
            }, {
              name: 'Biblioteca de 25 Perfiles de Puesto',
              included: true
            }, {
              name: 'Manual de SOPs con plantillas',
              included: true
            }, {
              name: 'Kit de Reclutamiento y Selección',
              included: true
            }, {
              name: 'Sistema de Onboarding completo',
              included: true
            }, {
              name: 'Plan de Implementación 30 Días (Toolkit)',
              included: true
            }, {
              name: 'Tablero de KPIs y Balanced Scorecard',
              included: true
            }, {
              name: 'Sistema de Gestión de Proyectos Ágil',
              included: true
            }, {
              name: 'Protocolo de Reuniones de Alta Gerencia',
              included: true
            }, {
              name: 'Matriz de Riesgos y Contingencias',
              included: true
            }, {
              name: 'Plan de Implementación 30 Días (Governance)',
              included: true
            }],
            style: 'border-amber-500/50 border-2 bg-slate-900',
            headerStyle: 'bg-amber-900/20 border-amber-500/30 text-amber-400',
            priceStyle: 'text-amber-400'
          }].map((tier, idx) => <div key={idx} className={`border rounded-xl overflow-hidden ${tier.style}`} data-id="element-441">
                <div className={`p-4 text-center border-b ${tier.headerStyle}`} data-id="element-442">
                  <h4 className="font-bold text-xl" data-id="element-443">{tier.title}</h4>
                  <p className={`text-2xl font-bold mt-2 ${tier.priceStyle}`} data-id="element-444">
                    {tier.price}
                  </p>
                </div>
                <div className="p-4 space-y-3" data-id="element-445">
                  {tier.features.map((f, i) => <div key={i} className="flex items-start gap-3 text-sm" data-id="element-446">
                      <div className="mt-0.5 flex-shrink-0" data-id="element-447">
                        {f.included ? <CheckIcon className="w-4 h-4 text-emerald-500" data-id="element-448" /> : <XIcon className="w-4 h-4 text-slate-600" data-id="element-449" />}
                      </div>
                      <span className={f.included ? 'text-slate-300' : 'text-slate-500'} data-id="element-450">
                        {f.name}
                      </span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}